import { UserProfile } from '../types';

// 行业知识图谱
export const industryKnowledgeMap = {
  finance: {
    focusAreas: ['金融科技', '资产管理', '风险控制', '合规监管'],
    caseStudies: [
      {
        title: 'DAAGE香港RWA资产代币化',
        description: '香港首个合规的RWA裸眼3D广告屏现实世界资产代币化平台',
        url: 'https://www.daage.io',
        tags: ['RWA', '资产代币化', '香港合规']
      },
      {
        title: '新加坡DBS银行RWA创新',
        description: 'DBS推出基于区块链的债券发行平台，实现T+1清算',
        url: 'https://www.dbs.com/newsroom/DBS_Digital_Bond',
        tags: ['债券代币化', '清算创新']
      }
    ],
    aiTools: [
      {
        name: 'LabbbFun AI',
        category: 'AI助手',
        description: 'AIGC-DAO自研的AI应用，支持金融分析和投资决策',
        icon: 'https://labbb.aigc-dao.com/favicon.ico',
        url: 'https://labbb.aigc-dao.com'
      },
      {
        name: 'Midjourney',
        category: 'AI创作',
        description: '领先的AI图像生成工具，支持金融数据可视化',
        icon: 'https://www.midjourney.com/favicon.ico',
        url: 'https://www.midjourney.com'
      }
    ],
    web3Tools: [
      {
        name: 'OneKey',
        category: '硬件钱包',
        description: '安全可靠的硬件钱包，支持多链资产管理',
        icon: 'https://onekey.so/favicon.ico',
        url: 'https://onekey.so'
      },
      {
        name: 'MetaMask',
        category: '软件钱包',
        description: '最流行的Web3钱包，支持多链资产管理',
        icon: 'https://metamask.io/icons/icon-48x48.png',
        url: 'https://metamask.io'
      }
    ]
  },
  tech: {
    focusAreas: ['软件开发', '云服务', '数据分析', '网络安全'],
    caseStudies: [
      {
        title: 'AIGC-DAO创新实验室',
        description: 'AI模型训练和应用开发最佳实践分享',
        url: 'https://www.aigc-dao.com/lab',
        tags: ['AI开发', '技术创新']
      },
      {
        title: 'Web3基础设施建设',
        description: '去中心化存储和计算服务实践案例',
        url: 'https://www.aigc-dao.com/web3',
        tags: ['基础设施', 'Web3']
      }
    ],
    aiTools: [
      {
        name: 'LabbbFun AI',
        category: 'AI助手',
        description: 'AIGC-DAO自研的AI应用，支持智能开发',
        icon: 'https://labbb.aigc-dao.com/favicon.ico',
        url: 'https://labbb.aigc-dao.com'
      },
      {
        name: 'DeepSeek',
        category: 'AI编程',
        description: '新一代AI编程助手，支持代码生成和优化',
        icon: 'https://deepseek.com/favicon.ico',
        url: 'https://deepseek.com'
      }
    ],
    web3Tools: [
      {
        name: 'OneKey',
        category: '硬件钱包',
        description: '安全可靠的硬件钱包，开发者必备工具',
        icon: 'https://onekey.so/favicon.ico',
        url: 'https://onekey.so'
      },
      {
        name: 'GitHub Copilot',
        category: 'AI编程',
        description: 'AI辅助编程工具，提升开发效率',
        icon: 'https://github.com/favicon.ico',
        url: 'https://github.com/features/copilot'
      }
    ]
  },
  healthcare: {
    focusAreas: ['医疗数据', '智能诊断', '远程医疗', '健康管理'],
    caseStudies: [
      {
        title: '医疗数据资产化创新',
        description: '基于区块链的医疗数据确权和交易平台案例',
        url: 'https://www.example.com/healthcare-data',
        tags: ['数据确权', '隐私保护']
      },
      {
        title: 'AI辅助诊断系统落地',
        description: '大型三甲医院AI影像诊断应用实践',
        url: 'https://www.example.com/ai-diagnosis',
        tags: ['AI诊断', '医疗创新']
      }
    ],
    aiTools: [
      {
        name: 'LabbbFun AI',
        category: 'AI助手',
        description: 'AIGC-DAO自研的AI应用，支持医疗数据分析',
        icon: 'https://labbb.aigc-dao.com/favicon.ico',
        url: 'https://labbb.aigc-dao.com'
      },
      {
        name: 'DeepSeek',
        category: 'AI编程',
        description: '新一代AI编程助手，支持医疗系统开发',
        icon: 'https://deepseek.com/favicon.ico',
        url: 'https://deepseek.com'
      }
    ],
    web3Tools: [
      {
        name: 'OneKey',
        category: '硬件钱包',
        description: '安全可靠的硬件钱包，支持医疗数据资产管理',
        icon: 'https://onekey.so/favicon.ico',
        url: 'https://onekey.so'
      },
      {
        name: 'MedicalChain',
        category: '医疗数据',
        description: '医疗数据存证和共享平台',
        icon: 'https://medicalchain.com/favicon.ico',
        url: 'https://medicalchain.com'
      }
    ]
  },
  education: {
    focusAreas: ['在线教育', '智能辅导', '教育评估', '内容创作'],
    caseStudies: [
      {
        title: '科大讯飞AI教学助手',
        description: '基于大模型的智能教学助手，已在多所学校落地应用',
        url: 'https://www.iflytek.com/news/1451.html',
        tags: ['AI教学', '智能助手', '教育科技']
      },
      {
        title: 'Duolingo AI个性化学习',
        description: '利用AI技术实现语言学习的个性化路径规划',
        url: 'https://blog.duolingo.com/ai-at-duolingo/',
        tags: ['个性化学习', '语言教育', 'AI应用']
      }
    ],
    aiTools: [
      {
        name: 'LabbbFun AI',
        category: 'AI助手',
        description: 'AIGC-DAO自研的AI应用，支持教育场景应用',
        icon: 'https://labbb.aigc-dao.com/favicon.ico',
        url: 'https://labbb.aigc-dao.com'
      },
      {
        name: 'Gradescope',
        category: '智能评分',
        description: '基于AI的作业和考试自动评分系统',
        icon: 'https://www.gradescope.com/favicon.ico',
        url: 'https://www.gradescope.com'
      }
    ],
    web3Tools: [
      {
        name: 'POAP',
        category: '学习认证',
        description: '基于区块链的成就和证书发放平台',
        icon: 'https://poap.xyz/favicon.ico',
        url: 'https://poap.xyz'
      },
      {
        name: 'LearnWeb3',
        category: '在线学习',
        description: 'Web3技术学习和认证平台',
        icon: 'https://learnweb3.io/favicon.ico',
        url: 'https://learnweb3.io'
      }
    ]
  },
  entertainment: {
    focusAreas: ['数字创作', '版权保护', '虚拟互动', '内容分发'],
    caseStudies: [
      {
        title: 'Stability AI开放创作平台',
        description: '基于开源AI模型的创意内容生成平台',
        url: 'https://stability.ai/news/stable-diffusion-3',
        tags: ['AI创作', '开源模型', '创意工具']
      },
      {
        title: 'Suno AI音乐创作',
        description: '基于AI的专业音乐创作平台，支持多风格音乐生成',
        url: 'https://www.suno.ai',
        tags: ['AI音乐', '创意工具', '数字音乐']
      }
    ],
    aiTools: [
      {
        name: 'Runway',
        category: 'AI视频',
        description: '专业的AI视频创作和编辑平台',
        icon: 'https://runway.com/favicon.ico',
        url: 'https://runway.com'
      },
      {
        name: 'Stable Diffusion',
        category: 'AI绘画',
        description: '开源的AI图像生成模型，支持本地部署',
        icon: 'https://stability.ai/favicon.ico',
        url: 'https://stability.ai'
      }
    ],
    web3Tools: [
      {
        name: 'OpenSea',
        category: 'NFT市场',
        description: '全球最大的NFT交易平台',
        icon: 'https://opensea.io/favicon.ico',
        url: 'https://opensea.io'
      },
      {
        name: 'Sound.xyz',
        category: '音乐NFT',
        description: '音乐NFT发行和交易平台',
        icon: 'https://sound.xyz/favicon.ico',
        url: 'https://sound.xyz'
      }
    ]
  }
};

// RWA项目数据
const rwaProjects = [
  {
    name: '香港RWA裸眼3D广告屏',
    minInvestment: 13000,
    expectedReturn: 0.08,
    description: '投资于真实世界资产结合的数字资产，可持续享受香港乃至海外XR裸眼3D广告屏未来8年的广告投放收益'
  },
];

// 生成行业建议
export function generateIndustryTips(user: UserProfile) {
  const industry = industryKnowledgeMap[user.industry.primary];
  
  if (!industry) {
    return {
      caseStudies: [],
      tools: [],
      opportunities: {
        rwa: []
      }
    };
  }

  // 根据用户选择的领域返回相应的工具
  const tools = user.interests.includes('AI') ? industry.aiTools : industry.web3Tools;

  return {
    caseStudies: industry.caseStudies,
    tools: tools,
    opportunities: {
      rwa: rwaProjects
    }
  };
}